export const selectTaskCustomFields = (state) => state.customFields.items



// WEBPACK FOOTER //
// ./web/js/customFields/selectors.js